import React, { useEffect, useRef, useState } from 'react';

interface ChatMessage {
  id: number;
  username: string;
  message: string;
  platform: string;
  wins: number;
  amount: number;
}

const ChatBox: React.FC = () => {
  const [messages, setMessages] = useState<ChatMessage[]>([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const chatContainerRef = useRef<HTMLDivElement>(null);

  // Generate mock data
  const generateMockData = (): ChatMessage[] => {
    const platforms = ['RR88', 'MM88', 'XX88'];

    const teenUsernames = [
        'boDoi999', 'truoi69', 'hacker-8', 'soaiCaDepTrai',
        'ngaoDa420', 'gaiXinh001', 'banHead100', 'thanBai88',
        'layNhatXom', 'daiCa9759', 'boTo31Dem', 'caMap77',
        'treTrauPro', 'banads', 'ngauloiao', 'deVuong88',
        'chuatedcen', 'beCung99', 'hamcamap', 'quayToiSang',
        'ganhTeam69', 'daiGia99', 'boD8', 'cucVang001',
        'banXuyenGiap', 'ngauNhuan', 'beHuProMax', 'daiHiep88',
        'bo-to121', 'gaixinh34', 'satThu12', 'quayBanDem',
        'noiconcac1', 'dev99', 'maxdien', 'cccung69',
        'banPhatNgat', 'ngauccDa', 'beHu9', 'daiHi',
        'cancucot_01', 'gza239', 'zzdfwdfHinh', '123213uayToiBen',
        '12312adwwr', 'asdfghjkl', 'bevun7', 'cute88',
        'xuyenmandem_84', 'duypham21', 'nohu1', 'taixiumd599'
      ];      

    const allUsernames = [...teenUsernames];

    const messages = [];
    for (let i = 0; i < 100; i++) {
      const username = allUsernames[Math.floor(Math.random() * allUsernames.length)];
      const platform = platforms[Math.floor(Math.random() * platforms.length)];
      const wins = Math.floor(Math.random() * 16) + 5; // 5-20 wins
      
      // Calculate amount based on wins (proportional)
      // 20 wins = 85,000,000, 5 wins = 8,000,000
      const minAmount = 8000000;
      const maxAmount = 85000000;
      const minWins = 5;
      const maxWins = 20;
      
      // Linear interpolation: amount = minAmount + (wins - minWins) * (maxAmount - minAmount) / (maxWins - minWins)
      const amount = Math.round(
        minAmount + (wins - minWins) * (maxAmount - minAmount) / (maxWins - minWins)
      );
      
      // Round to nearest 1000 (2 zeros at the end)
      const roundedAmount = Math.round(amount / 1000) * 1000;
      
      messages.push({
        id: i + 1,
        username,
        message: `đã thắng ${wins} ván tại ${platform} win ${roundedAmount.toLocaleString('vi-VN')} VNĐ`,
        platform,
        wins,
        amount: roundedAmount
      });
    }
    return messages;
  };

  useEffect(() => {
    setMessages(generateMockData());
  }, []);

  // Auto scroll every 2 seconds - cycle through messages
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prevIndex => {
        const nextIndex = prevIndex + 1;
        return nextIndex >= messages.length ? 0 : nextIndex;
      });
    }, 2000);

    return () => clearInterval(interval);
  }, [messages.length]);

  return (
    <div 
      className="fixed bottom-2 right-4 w-80 h-44 overflow-hidden z-50"
      style={{
        backgroundImage: "url('/assets/chat-frame.png')",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center"
      }}
    >
      {/* Chat Messages */}
      <div 
        ref={chatContainerRef}
        className="h-full overflow-y-auto p-6 space-y-2 mt-1"
        style={{ scrollbarWidth: 'none' }}
      >
        {messages.slice(currentIndex, currentIndex + 2).map((msg, index) => {
          // Random colors for username (mostly red like in image)
          const usernameColors = [
            'text-red-500', 'text-red-400', 'text-red-600', 'text-red-300',
            'text-yellow-400', 'text-blue-400', 'text-purple-400', 'text-pink-400',
            'text-cyan-400', 'text-orange-400', 'text-green-400', 'text-indigo-400'
          ];
          const randomColor = usernameColors[Math.floor(Math.random() * usernameColors.length)];
          
          return (
            <div 
              key={msg.id} 
              className={`text-xm text-white leading-tight p-2 rounded transition-all duration-500 ${
                index === 0 ? 'bg-gray-800 bg-opacity-90' : 'bg-gray-900 bg-opacity-30'
              }`}
            >
              <span className={`${randomColor} font-bold`}>{msg.username}</span>
              <span className="text-white"> đã thắng {msg.wins} ván tại </span>
              <span className="text-white font-semibold">{msg.platform}</span>
              <span className="text-white"> win </span>
              <span className="text-green-400 font-bold">{msg.amount.toLocaleString('vi-VN')} VNĐ</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ChatBox;
